// Libraries
import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  // Chat,
  // InfoLine,
  MenuThick,
} from 'sushiweb/Icons';
// import grey from 'sushiweb/tokens/color/grey';
import {
  EMPLOYEES_ROUTE,
  // GIFTING_ROUTE,
  HOME_ROUTE,
  PAYMENTS_ROUTE,
  PROGRAMS_ROUTE,
  REPORTS_ROUTE,
  // REPORTS_ROUTE,
  // SUPPORT,
} from '../../../../constants/routes';
import {
  BottomWrapper,
  ComingSoonDiv,
  NavbarWrapper,
  StyledDiabledLink,
  StyledLink,
  ZFELogoWrapper,
} from './styles';
import { logoutUser } from '../../../../actions/auth';
import { openErrorToast } from '../../../../reducers/uiLogic';
import {
  EmployeesIcon,
  // GiftingIcon,
  HomeIcon,
  MealPlanIcon,
  PaymentsIcon,
  ReportsIcon,
} from '../../../../components/SVGs/SideNavSVGs';
import { isConnectedToStagging } from '../../../../helpers';
import { FOOD_AT_WORK_LOGO_IMG } from '../../../../constants/images';
import { applicableFlowTypes, currentFlowTypeEnum } from '../constants';

const RouteButton = ({ route, icon, label, disabled, isFirst }) => {
  if (disabled) {
    return (
      <StyledDiabledLink isFirst={isFirst}>
        <div>
          {' '}
          {icon}
          {' '}
        </div>
        <p>{label}</p>
        <ComingSoonDiv>
          {' '}
          <span>COMING </span>
          {' '}
          <span> SOON </span>
        </ComingSoonDiv>
      </StyledDiabledLink>
    );
  }

  return (
    <StyledLink isFirst={isFirst} to={route}>
      <div id='activeIcon'>
        {' '}
        {icon}
        {' '}
      </div>
      <p id='activeText'>{label}</p>
    </StyledLink>
  );
};

const ZFELogo = () => {
  return (
    <NavLink to={HOME_ROUTE} className={() => ''}>
      {' '}
      <img
        src={FOOD_AT_WORK_LOGO_IMG}
        height='35rem'
        alt='Zomato for enterprise'
      />
    </NavLink>
  );
};

RouteButton.propTypes = {
  route: PropTypes.string,
  icon: PropTypes.element,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  isFirst: PropTypes.bool,
};

RouteButton.defaultProps = {
  route: HOME_ROUTE,
  icon: <MenuThick />,
  label: '',
  disabled: false,
  isFirst: false,
};

const SideNavbar = ({
  isLoggedIn,
  verified,
  isOnlinePaymentsEnabled,
  isReportsTabEnabled,
  // isGiftingFlowSupported,
  currentFlow,
}) => {
  if (verified) console.log(verified);
  return isLoggedIn ? (
    <NavbarWrapper isStagging={isConnectedToStagging()}>
      <ZFELogoWrapper isStagging={isConnectedToStagging()}>
        <ZFELogo />
        {' '}
      </ZFELogoWrapper>
      <RouteButton route={HOME_ROUTE} icon={HomeIcon} label='Home' />
      <RouteButton
        route={EMPLOYEES_ROUTE}
        icon={EmployeesIcon}
        label='Employees'
      />
      <RouteButton
        route={PROGRAMS_ROUTE}
        icon={MealPlanIcon}
        label='Meal Plans'
      />
      <RouteButton
        route={PAYMENTS_ROUTE}
        icon={PaymentsIcon}
        label='Payments'
        disabled={!isOnlinePaymentsEnabled}
      />
      {currentFlow === currentFlowTypeEnum.FLOW_TYPE_LIMIT && (
        <RouteButton
          route={REPORTS_ROUTE}
          icon={ReportsIcon}
          label='Reports'
          disabled={!isReportsTabEnabled}
        />
      )}
      {/* <hr color={grey.z200} />
      <RouteButton
        route={GIFTING_ROUTE}
        icon={GiftingIcon}
        label='Gifting'
        disabled={!isGiftingFlowSupported}
      /> */}
      {/* <RouteButton
        route={REPORTS_ROUTE}
        icon={<Chat {...iconProps} />}
        label='Reports'
      /> */}
      <BottomWrapper>
        {/* <RouteButton
          route={SUPPORT}
          icon={<InfoLine {...iconProps} />}
          label='Support'
        /> */}
      </BottomWrapper>
    </NavbarWrapper>
  ) : null;
};

SideNavbar.propTypes = {
  verified: PropTypes.bool,
  isLoggedIn: PropTypes.bool,
  isOnlinePaymentsEnabled: PropTypes.bool,
  isReportsTabEnabled: PropTypes.bool,
  // isGiftingFlowSupported: PropTypes.bool,
  currentFlow: PropTypes.oneOf(applicableFlowTypes),
};

SideNavbar.defaultProps = {
  verified: false,
  isLoggedIn: false,
  isOnlinePaymentsEnabled: false,
  isReportsTabEnabled: false,
  // isGiftingFlowSupported: false,
  currentFlow: currentFlowTypeEnum.FLOW_TYPE_PPI,
};

const mapDispatchToProps = dispatch => ({
  showErrorToast: () => dispatch(openErrorToast()),
  logUserOut: () => dispatch(logoutUser()),
});

export default connect(
  null,
  mapDispatchToProps,
)(SideNavbar);
